/* global axios */
import ApiClient from '../ApiClient';

class DealStatusAPI extends ApiClient {
  constructor() {
    super('pipeline/cards', { accountScoped: true });
  }

  // `items` descreve O QUE foi vendido (Fase 59/F5): N linhas, cada uma com
  // produto, quantidade e unitário. Sem isso a venda entra no razão sem produto
  // vinculado e não pode ser medida por produto na tela de Oportunidades.
  //
  // `productId`/`quantity`/`unitValue` são a forma de UMA linha só, anterior à
  // F5. Continuam aceitos porque o contrato está publicado e há integração
  // externa usando — o servidor trata os dois. Quando `items` vem, ele vence:
  // é o que o backend faz, e mandar as duas formas juntas descreveria duas
  // vendas diferentes no mesmo pedido.
  markAsWon(
    itemId,
    {
      wonValue,
      wonNote,
      winningOfferIndex,
      productId,
      quantity,
      unitValue,
      items,
    } = {}
  ) {
    const payload = {};
    if (wonValue !== undefined && wonValue !== null && wonValue !== '') {
      payload.won_value = wonValue;
    }
    if (wonNote !== undefined && wonNote !== null && wonNote !== '') {
      payload.won_note = wonNote;
    }
    if (winningOfferIndex !== undefined && winningOfferIndex !== null) {
      payload.winning_offer_index = winningOfferIndex;
    }
    if (Array.isArray(items) && items.length) {
      payload.items = items.map(item => {
        const linha = { pipeline_product_id: item.pipelineProductId };
        if (
          item.title !== undefined &&
          item.title !== null &&
          item.title !== ''
        ) {
          linha.title = item.title;
        }
        if (item.quantity !== undefined && item.quantity !== null) {
          linha.quantity = item.quantity;
        }
        if (item.unitValue !== undefined && item.unitValue !== null) {
          linha.unit_value = item.unitValue;
        }
        // `total_value` NÃO vai: o servidor deriva de quantidade × unitário e,
        // recebendo os três, recusa com 422 qualquer divergência de
        // arredondamento entre navegador e servidor numa venda correta.
        return linha;
      });
      return axios.post(`${this.url}/${itemId}/deal_status/mark_won`, payload);
    }
    if (productId !== undefined && productId !== null && productId !== '') {
      payload.pipeline_product_id = productId;
      // Quantidade e unitário só fazem sentido acompanhando o produto: soltos,
      // descreveriam um item que a venda não tem.
      if (quantity !== undefined && quantity !== null && quantity !== '') {
        payload.quantity = quantity;
      }
      if (unitValue !== undefined && unitValue !== null && unitValue !== '') {
        payload.unit_value = unitValue;
      }
    }
    return axios.post(`${this.url}/${itemId}/deal_status/mark_won`, payload);
  }

  markAsLost(itemId, reason) {
    return axios.post(`${this.url}/${itemId}/deal_status/mark_lost`, {
      reason,
    });
  }

  reopen(itemId) {
    return axios.post(`${this.url}/${itemId}/deal_status/reopen`);
  }

  getLostReasonsAnalytics({ startDate, endDate } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/lost_reasons`,
      { params }
    );
  }

  getCommonReasons() {
    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/common_reasons`
    );
  }
}

export default new DealStatusAPI();
